import { cn } from '@jotta/utils/css'

import type { FileListRowObject } from './fileListUtils'

export const FileListRow = ({ row }: { row: FileListRowObject }) => {
  return (
    <div
      className={cn({
        'border-b border-light': row.view === 'list',
      })}
      key={row.key}
      style={row.style}
    >
      {row.view === 'list'
        ? row.renderItem(row.rowIndex, row.key, 'list')
        : row.items.map(item => row.renderItem(item.index, item.key, 'thumbs'))}
    </div>
  )
}
